import loadScript from 'lib/loadScript';

export default async function loadVilynxPlugin() {
  await loadScript(
    '//static.vilynx.com/plugins/nbcnews-vilynx.1.1.1.min.js',
    {
      location: 'body',
      attributes: {
        redirect: true,
        redirectwithclick: true,
        userid: 'a5d3c400d9872cc4aa3bb4e9c87c7cab',
        resizetoimage: true,
        forcetoimageparent: true,
        onpluginload: '(function (e) {});',
      },
    },
  );
}
